import { Component } from 'react';
import { css } from "@pandacss/css";
import {ArrowLeftIcon, ArrowRightIcon} from "../atoms/Icon";

interface Props {
    imageSources: string[];
}

interface State {
    currentImageIndex: number;
}

const containerClass = css({
    height: '200px',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px',
});

const imageClass = css({
    height: '200px',
    width: '100%',
    objectFit: 'cover',
    transition: 'transform 0.5s ease-in-out',
});

const buttonBaseClass = css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'neutral.800',
    borderRadius: 'full',
    padding: '4px',
    cursor: 'pointer',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'md',
});

const leftButtonClass = css({
    left: '8px',
});

const rightButtonClass = css({
    right: '8px',
});

class ImageCarousel extends Component<Props, State> {
    state: State = {
        currentImageIndex: 0,
    };

    handlePrev = () => {
        this.setState((prevState) => ({
            currentImageIndex:
                (prevState.currentImageIndex - 1 + this.props.imageSources.length) %
                this.props.imageSources.length,
        }));
    };

    handleNext = () => {
        this.setState((prevState) => ({
            currentImageIndex:
                (prevState.currentImageIndex + 1) % this.props.imageSources.length,
        }));
    };

    render() {
        const { imageSources } = this.props;
        const { currentImageIndex } = this.state;

        return (
            <div className={containerClass}>
                {imageSources.map((src, index) => (
                    <img
                        key={index}
                        src={src}
                        alt={`Slide ${index + 1}`}
                        className={imageClass}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: `${(index - currentImageIndex) * 100}%`,
                            transition: 'left 0.5s ease-in-out',
                        }}
                    />
                ))}
                { imageSources.length > 1 && <>
                    <div
                        className={`${buttonBaseClass} ${leftButtonClass}`}
                        onClick={this.handlePrev}
                    >
                        <ArrowLeftIcon size={24} />
                    </div>
                    <div
                        className={`${buttonBaseClass} ${rightButtonClass}`}
                        onClick={this.handleNext}
                    >
                        <ArrowRightIcon size={24} />
                    </div>
                </>}
            </div>
        );
    }
}

export default ImageCarousel;
